import { UserRole } from 'shared/types/userRole';

export function isClientAdmin(role: UserRole): boolean {
  return role === UserRole.organizationAdmin;
}
